import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import CountDown from './CountDown';
import Spinner from './Spinner';
import Image from './Image';

const ResetByMail = ({
  data = {},
  method,
  type,
  sendOtp = () => {},
  resetByOtp = () => {},
  handleBack = () => {}
}) => {
  const [showCountDown, setShowCountDown] = useState(false);
  const [otpLifeTime, setOtpLifeTime] = useState();
  const [time, setTime] = useState({});
  const [showTimeLock, setShowTimeLock] = useState(false);
  const [timeLock, setTimeLock] = useState({});

  // useEffect(() => {
  //   if (!data.loading) {
  //     setShowTimeLock(!!data.userStatusInfos.remain_many_request_wait_time);
  //   }
  // }, [data.loading]);

  const initialValues = {
    otp: '',
  };

  const validate = () => {
    return Yup.object().shape({
      otp: Yup.string().required('Hãy nhập thông tin'),
    });
  };

  const handleFormSubmit = (data, resetForm) => {
    const paramsSubit = {"otp": data.otp, "method": method, "password_type": type}
    const resetLevel = type == 'PASSWORD_TYPE_2' ? 'CẤP 2' : type == 'PASSWORD_TYPE_3' ? 'CẤP 3' : ''

    resetByOtp(JSON.stringify(paramsSubit), resetLevel);
  };

  const handleClickSendOTP = (e) => {
    e.preventDefault();

    if (data.isSendingOtp) {
      return;
    }
    const params = {method, "password_type": type}

    sendOtp(JSON.stringify(params), method, type, (respon) => {

      setShowTimeLock(!!respon?.otp_life_time);
      setOtpLifeTime(parseInt(respon?.otp_life_time))
      setShowCountDown(true);
    });
  };

  const handleEndCountDown = () => {
    setShowCountDown(false);
  };

  const handleTimerTick = (time) => {
    setTime(time);
  };

  const handleBackHome = (e) => {
    e.preventDefault()
    handleBack()
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={validate()}
      initialValues={initialValues}
      onSubmit={(values, { resetForm }) => handleFormSubmit(values, resetForm)}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting
      }) => (
        <form action="" className="lock-account" onSubmit={handleSubmit}>
          <div className="form-group lock-account__name">
            <label htmlFor="emailInput">Email</label>
            <input
              type="text"
              name="email"
              id="emailInput"
              value={data?.configuration?.email_method?.email}
              className="form-control"
              disabled
              readOnly
            />
          </div>
          <div className="form-group lock-account__otp">
            <label htmlFor="otpInput">Mã OTP</label>
            <input
              type="text"
              name="otp"
              id="otpInput"
              value={values.otp}
              className={`form-control ${errors.otp && touched.otp ? 'is-invalid' : ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <div className="lock-account__send-otp">
              {data.isSendingOtp ? <Spinner/> : (
                <a
                  href="#"
                  title="Gửi mã"
                  className={`btn-hover-scale ${showTimeLock ? 'disabled' : ''}`}
                  onClick={e => handleClickSendOTP(e)}
                >
                  <Image src="images/btn-send-code.png"/>
                </a>
              )}
            </div>
            {errors.otp && touched.otp && (<div className="invalid-feedback">{errors.otp}</div>)}
            {/* {showCountDown && !showTimeLock && otpLifeTime &&  (
              <CountDown
                prefix="Mã OTP sẽ hết hiệu lực trong"
                minutes={parseInt(otpLifeTime/60)}
                onEnded={() => handleEndCountDown()}
                onTick={time => handleTimerTick(time)}
              />
            )} */}
            {showTimeLock && otpLifeTime && (
              <CountDown
                prefix="Lấy mã OTP mới sau"
                minutes={parseInt(otpLifeTime/60)}
                onEnded={() => setShowTimeLock(false)}
                onTick={time => setTimeLock(time)}
              />
            )}
          </div>
          <div className="lock-account__submit">
            {data.isResettingByOtp ? <Spinner/> : (
              <>
                <a href="#" className="btn-back btn-hover-scale" onClick={e => handleBackHome(e)}>Quay lại</a>
                <button type="submit" className="btn-hover-scale" title="Xác nhận">
                  <Image src="images/btn-submit.png"/>
                </button>
              </>
            )}
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ResetByMail;
